export default __webpack_public_path__ + "static/media/ponta_logo.af221766.png";